import React from 'react'
import AboutBG from './images/imageAssets/AboutBG.png'
import a01 from './images/aboutUSImages/01.jpg'
import a02 from './images/aboutUSImages/02.jpg'
import a03 from './images/aboutUSImages/03.jpg'
import a04 from './images/aboutUSImages/04.jpg'
import a05 from './images/aboutUSImages/05.jpg'

function AboutUs() {
  return (
    <section id='AboutSection'>
      <img aria-hidden='true' src={AboutBG} alt="" className="section-background-image AboutBG" />
      <div className="container">
        <header className=''>
          <h2 className="section-header asset-underline">about us</h2>
        </header>
        <p className="paragraph">Centerline Cabinets is your destination for all your cabinet and furniture needs. We have been in business for over 18 years. Sepecializing in both remodel and new build jobs, our custon-built products will give your home the perfect combination of aesthetics and functionality.</p>
        <div className="About-us-wrapper">
          
          <div className="Crafting-dreams-wrapper">
            <h2 className="subheader asset-underline margin-bottom">crafting dreams</h2>
            <p className="paragraph">At our core, we excel in crafting bespoke, top-tier cabinetry and furniture tailored to your exact specifications. Backed by a team of seasoned experts, we guide you seamlessly through every stage of your project. Whether it's conceptualizing the design or ensuring flawless delivery, our dedicated staff is committed to bringing your vision to life with unparalleled expertise and care.</p>
          </div>
          <div className="Our-Promise-wrapper-outter">

            <div className="Our-Promise-wrapper">
              <div className="Our-Promise-image-gallery">
                <div className="Our-Promise-image-gallery-item">
                  <img src={a01} alt="" className="Our-Promise-image" />
                </div>
                <div className="Our-Promise-image-gallery-item">
                  <img src={a02} alt="" className="Our-Promise-image" />
                </div>
                <div className="Our-Promise-image-gallery-item">
                  <img src={a03} alt="" className="Our-Promise-image" />
                </div>
                <div className="Our-Promise-image-gallery-item">
                  <img src={a04} alt="" className="Our-Promise-image" />
                </div>
                <div className="Our-Promise-image-gallery-item">
                  <img src={a05} alt="" className="Our-Promise-image" />
                </div>
              </div>
              <h2 className="section-header">our promise</h2>
            </div>
            <p className="paragraph">Elevating your home with premium cabinet solutions. With an unwavering commitment to excellence, we promise to enhance your living space with the finest quality products, ensuring unparalleled comfort and admiration from your loved ones.</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AboutUs